module.exports = __webpack_public_path__ + "static/media/points8_2.cee3e1f7.png";